import { render, staticRenderFns } from "./MbgAccordionItem.vue?vue&type=template&id=58f128f5&"
import script from "./MbgAccordionItem.vue?vue&type=script&lang=js&"
export * from "./MbgAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./MbgAccordionItem.vue?vue&type=style&index=0&id=58f128f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports